import useTranslation from 'next-translate/useTranslation';
import { Controller } from 'react-hook-form';

import { Translate } from '@core/constant';
import { EColor, ECurrency, ESize, EZIndexName } from '@core/type';

import { InputWrapper } from '../../input';
import { FieldError } from '../../input/FieldError';
import { InputNumberBase } from '../../input/InputNumberBase';
import { Box } from '../../layout';
import { SelectCurrency, SelectCurrencyOptionContent } from '../../select';
import { InputNumberControlProps } from './interface-form-input';

export const InputAmountCurrencyControl = ({
  currency,
  control,
  name,
  size,
  ...inputProps
}: InputNumberControlProps) => {
  const { t } = useTranslation(Translate.common.CURRENCY);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <InputWrapper
            display={'flex'}
            position={'relative'}
            padding={size === ESize.LG ? '16px 0 16px 16px' : '12px 0 12px 16px'}
            backgroundColor={{ semanticType: EColor.NEUTRAL, variant: EColor.LIGHT }}
          >
            <Box position={'relative'} zIndex={EZIndexName.OVER_DEFAULT}>
              {currency ? (
                <SelectCurrencyOptionContent
                  currency={currency}
                  color={EColor.PRIMARY}
                  isLongForm={false}
                  fontSize="15px"
                  t={t}
                  gap="8px"
                />
              ) : (
                <Controller
                  name={'currency'}
                  control={control}
                  render={({ field: fieldCurrency }) => (
                    <SelectCurrency
                      iconColor={EColor.PRIMARY}
                      color={EColor.PRIMARY}
                      fn={fieldCurrency.onChange}
                      value={fieldCurrency.value as ECurrency}
                      width={'96px'}
                      marginRight={'20px'}
                      gap="8px"
                    />
                  )}
                />
              )}
            </Box>

            <Box
              position={'absolute'}
              left={'0'}
              padding={size === ESize.LG ? '16px 16px 16px 128px' : '12px 16px 12px 128px'}
              top={'0'}
              width={'100%'}
              textOverflow={'ellipsis'}
            >
              <InputNumberBase field={field} fieldState={fieldState} {...inputProps} />
            </Box>
          </InputWrapper>
          <FieldError fieldState={fieldState} {...inputProps} />
        </>
      )}
    />
  );
};
